import React from 'react'
import PropTypes from 'prop-types'
import { DYNAMIC } from 'constants/featureTypes'
import { propEq } from 'ramda'
import {
  StyledCollapsibleWidget,
  StyledList,
  StyledListItem,
} from '../FeaturesTable.style'

const CollapsibleDesc = ({ record, data, isExpanded }) => {
  const isDynamicFeature = propEq('type', DYNAMIC, record)
  const commonOutputFeatures = data.filter((item) =>
    record.commonOutputFeatures?.includes(item.uri)
  )

  return isDynamicFeature ? (
    <StyledCollapsibleWidget
      className="dynamic-feat-collapse"
      panelClassName="dynamic-feat-collapse-panel"
      header={record.description}
      ghost
      showArrow={false}
      activeKey={isExpanded ? '1' : '0'}
    >
      <StyledList
        bordered
        dataSource={commonOutputFeatures}
        renderItem={(item) => (
          <StyledListItem>
            {item.partNumber} - {item.description}
          </StyledListItem>
        )}
      />
    </StyledCollapsibleWidget>
  ) : (
    record.description
  )
}
const Record_Shape = {
  id: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.string,
}

CollapsibleDesc.propTypes = {
  record: PropTypes.any,
  isExpanded: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape(Record_Shape)),
}

export default CollapsibleDesc
